<template>
  <div id="favoritenlisteAnzeige" class="box">
    <h2 class="favorite">Favoriten</h2>
    <loading-container :state="state" errormsg="Beim Laden ist ein Fehler aufgetreten.">
      <ul class="list-unstyled mb-2" v-if="favourites.length >0">
        <li v-for="(favorite, index) in favourites" :key="index" class="show-arrow">
            <a :href="sanitizeUrl(favorite.resolvedUrl || favorite.externalUrl)" class="file" target="_blank" rel="noreferrer noopener">
              <span class="icon icon-navigation_pfeil_rechts_mittel" aria-hidden="true"></span>
            {{ favorite.resolvedName||favorite.name}}</a>
        </li>
    </ul>
    <div v-else>
      Keine Favoriten gesetzt.
    </div>
    </loading-container>
    <div class="show-arrow linktolist font-weight-bold mb-3">
      <a :href="sanitizeUrl(verweisAlleLinks())">zur Linkverwaltung
        <i class="fas fa-chevron-right ms-1" aria-hidden="true"></i>
      </a>

    </div>
  </div>
</template>
<script lang="ts">
import { defineComponent } from 'vue'
import LoadingMixin from './mixins/LoadingMixin'
import LoadingContainer from './components/structure/LoadingContainer.vue'
import { sanitizeUrl } from '@braintree/sanitize-url'
import { BmfwfLinkResolved } from './models/BmfwfLinkverwaltung'
import linkverwaltungService from './services/linkverwaltungService'

export default defineComponent({
  props:{
    favoritenlisteJsonUrl: {
      type: String,
      required: true
    }
  },
  name: 'WidgetLinkFavoriten',
  mixins: [
    LoadingMixin
  ],
  components: {
    LoadingContainer
  },
  data() {
    return {
      favourites: [] as BmfwfLinkResolved[],
      sanitizeUrl: sanitizeUrl
    }
  },

  created() {
    this.getListItems()
  },

  methods: {

    verweisAlleLinks(): string  {
     return (document.querySelector('[data-vue-widget-bmfwf-linkanzeige-favoritenlinkliste]') as HTMLElement).dataset.vueWidgetBmfwfLinkanzeigeFavoritenlinkliste ||'/'
    },

     getListItems(){
     linkverwaltungService
      .getMyLinksBmfwf(this.favoritenlisteJsonUrl)
      .then(links => {
        this.favourites = links
        this.handleSuccess()
        this.getfavorites()
      }).catch(this.handleError)
    },

    getfavorites() {
      if(this.favourites.filter(obj => (obj.favorite))){
        const favoriten=JSON.stringify(this.favourites.filter(obj => obj.favorite));
        this.favourites=JSON.parse(favoriten)
      return JSON.stringify(this.favourites)
      }
    },
  }
})
</script>
<style scoped>

#favoritenlisteAnzeige{

  padding-left:12px;
  margin-top:0px;
  border-bottom-color: rgba(0, 0, 0, 0);

  template{
    display: block;
  }

  .favorite{
      font-weight: 600 !important;
      color:black !important
    }
  .fa-chevron-right{
    font-size: 11px;

    ::before {
      content: "\f054";
  }
  }
  .linktolist{
    padding-top: 8px;
    margin-top: 8px;
    display:flex;
    justify-content: flex-end;
  }

}


</style>
